import { parseClientEnv, siteUrl, turnstileSiteKey } from '@inboxkit/env/sites';

/** Build-time overrides (VITE_*_URL, Turnstile key). */
export const siteEnv = parseClientEnv(import.meta.env);
const env = siteEnv;

export const API_URL = siteUrl('api', { env });
export const APP_URL = siteUrl('app', { env });
export const MARKETING_URL = siteUrl('marketing', { env });
export const STATUS_URL = siteUrl('status', { env });
export const TURNSTILE_SITE_KEY = turnstileSiteKey(env);
